import { render, staticRenderFns } from "./quote-grid-descriptions.vue?vue&type=template&id=d2bfb31c&scoped=true"
import script from "./quote-grid-descriptions.vue?vue&type=script&lang=js"
export * from "./quote-grid-descriptions.vue?vue&type=script&lang=js"
import style0 from "./quote-grid-descriptions.vue?vue&type=style&index=0&id=d2bfb31c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2bfb31c",
  null
  
)

export default component.exports